import { QueryClient } from "@tanstack/react-query";

/**
 * Feature flag for more aggressive React Query defaults in production:
 * - Longer staleTime / gcTime to reduce refetches
 * - refetchOnWindowFocus: false to avoid refetch when switching tabs
 * Set VITE_REACT_QUERY_PERF=true to enable in dev; in production we enable by default.
 */
const isQueryPerfEnabled =
  import.meta.env.PROD || import.meta.env.VITE_REACT_QUERY_PERF === "true";

const defaultStaleTime = isQueryPerfEnabled ? 2 * 60 * 1000 : 0; // 2 min in perf mode
const defaultGcTime = isQueryPerfEnabled ? 10 * 60 * 1000 : 5 * 60 * 1000; // 10 min perf, 5 min default
const refetchOnWindowFocus = !isQueryPerfEnabled;

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: defaultStaleTime,
        gcTime: defaultGcTime,
        refetchOnWindowFocus,
      },
    },
  });
}
